import { useContext } from 'react';
import { NATCacheContext } from './NATCacheContext';

export function useNATCache() {
  const context = useContext(NATCacheContext);
  if (!context) {
    throw new Error('useNATCache must be used within a NATCacheProvider');
  }
  return context;
}
